import { ReactElement }                         from 'react';
import { createRoot, render }                   from '@wordpress/element';
import ReactDOM                                 from 'react-dom';

const reactVersion = ReactDOM.version || '';

export default function cfwRenderComponentIfElementExists( elementId: string, component: ReactElement, condition = true ): void {
    console.log(`[CFW Render] Attempting to render component in element: ${elementId}`, {
        elementId,
        condition,
        hasComponent: !!component,
    });

    const element = document.getElementById( elementId );

    console.log(`[CFW Render] Element lookup result:`, {
        elementId,
        elementExists: !!element,
        element,
    });

    if ( !element ) {
        console.warn(`[CFW Render] Element not found: ${elementId}`);
        return;
    }

    if ( !condition ) {
        console.warn(`[CFW Render] Condition failed for element: ${elementId}`);
        return;
    }

    console.log(`[CFW Render] React version: ${reactVersion}`);

    try {
        if ( reactVersion.startsWith( '18' ) ) {
            console.log(`[CFW Render] Using React 18 createRoot for: ${elementId}`);
            const root = createRoot( element );
            root.render( component );
        } else {
            console.log(`[CFW Render] Using legacy render for: ${elementId}`);
            render( component, element );
        }
        console.log(`[CFW Render] Successfully rendered component in: ${elementId}`);
    } catch (error) {
        console.error(`[CFW Render] Error rendering component in ${elementId}:`, error);
    }
}
